/**
 * ReportWriteShell — rc(@safetyhub/report-composer) 정본의 web 어댑터 래퍼.
 * 2026-07-26 rc 승격(시뮬레이션 chrome 배포판 동일화) — rc는 router 무의존이라
 * backLink 라우팅(useNavigate replace)과 fatalError '돌아가기' 링크(react-router Link)를
 * 여기서 주입한다. 기존 web 소비처는 이 경로·props 그대로(1비트 불변).
 */
import { Link, useNavigate } from 'react-router-dom';
import { ReportWriteShell as SharedReportWriteShell } from '@safetyhub/report-composer';
import type { ReportWriteShellProps } from '@safetyhub/report-composer';

export function ReportWriteShell(
  props: Omit<ReportWriteShellProps, 'onNavigateBack' | 'renderLink'>,
) {
  const navigate = useNavigate();
  return (
    <SharedReportWriteShell
      {...props}
      onNavigateBack={(to) => navigate(to, { replace: true })}
      renderLink={({ to, className, children }) => (
        <Link to={to} className={className}>
          {children}
        </Link>
      )}
    />
  );
}
